import { QueryClient } from '@tanstack/react-query';

/**
 * Один екземпляр на застосунок. retry: false свідомо —
 * повтори втричі збільшують затримку реальних відмов і ховають проблеми сервера (§26).
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: false, staleTime: 30_000, refetchOnWindowFocus: false },
	},
});
